const AFFILIATE = {
  INTRO_TITLE: 'همکاری در فروش',
  INTRO_SUB_TITLE: 'شراکت در درآمد رایچت',
  INTRO_DESC:
    'اگر در حوزه طراحی وب فعال هستید، می‌توانید از طریق همکاری در فروش رایچت درآمد کسب کنید. با ثبت نام در سایت ما، یک لینک دعوت دریافت می‌کنید. این لینک دعوت را به دیگران برای استفاده از خدمات رایچت ارائه کنید. از هر خرید اولیه ۲۰% و از خریدهای بعدی ۱۰% سود به شما تعلق می‌گیرد، که در کیف پول رایچت ذخیره و قابل برداشت نقدی یا استفاده برای تمدید خدمات است.',
  LINK_INTRO_TITLE: 'لینک دعوت',
  LINK_INTRO_DESC:
    'به عنوان سفیر رایچت، لینک دعوت خود را به دیگران ارائه دهید و سهم خود از فروش را دریافت کنید:',
  LINK_INPUT_TITLE: 'لینک را کپی کنید و در اختیار دوستان خود قرار دهید.',
  BENEFIT_TITLE: 'سود خرید شما',
  BENEFIT_TITLE_DESC: 'سود خرید های بعدی 10%',
  BENEFIT_BOX_ALL: 'کل ثبت نامی های شما',
  BENEFIT_BOX_PURCHASE_NUM: 'تعداد پکیج خریداری شده',
  BENEFIT_BOX_INCOME: 'درآمد شما از فروش',
  BENEFIT_BOX_INCOME_CURRENCY: 'تومان',
  BENEFIT_BOX_REGISTERS_UNIT: 'ثبت نام',
  BENEFIT_BOX_PACKAGES_UNIT: 'پکیج',

  COPY_CLICK_TOOLTIP: 'برای کپی کلیک کنید!',
  LINK_COPIED_MSG: 'کپی شد!',

  SALES_REPORT_TAB: 'گزارش‌های فروش',
  CHECKOUT_TAB: 'تسویه حساب',
  SALES_REPORT_DESC:
    'در این بخش میتونید آمار خرید کاربرانی که از طریق لینک شما در رایچت پکیج خریداری کردند را همراه با ریز جزئیات و مقدار سود خود از هر خرید، مشاهده کنید.',
  SALES_REPORT_NOTFOUND: 'نتیجه ای یافت نشد!',
  SALES_REPORT_NOTFOUND_DESC: `در این بخش، می‌توانید آمار خرید کاربران
  از طریق لینک شما را به همراه جزئیات هر خرید 
  و میزان سودتان مشاهده کنید.
  `,
  PAYMENT_TITLE: `
  زمانی که درامد ماهانه شما در رایچت به حداقل 500 هزارتومان برسد، می‌توانید درخواست تسویه حساب خود را ثبت نمایید. سپس کارشناسان ما برای تسویه حساب با شما ارتباط خواهند گرفت.
  شما در هر زمان می‌توانید “فقط یک درخواست فعال” به منظور تسویه حساب داشته باشید و امکان ارسال چند درخواست همزمان وجود ندارد.
  `,
  PAYMENT_AMOUNT: 'مبلغ قابل تسویه',
  ACCOUNT_INFO: 'اطلاعات حساب',
  ACCOUNT_INFO_DESC: 'برای تسویه حساب اطلاعات خود را وارد کنید.',
  ACCOUNT_NUM_PLACEHOLDER: 'شماره شبا',
  ACCOUNT_OWNER_PLACEHOLDER: 'نام صاحب حساب',
  BANK_PLACEHOLDER: 'نام بانک',
  PAYMENT_RESULT_TITEL: 'نتیجه‌ای یافت نشد!',
  PAYMENT_RESULT_DESC: `
  در این قسمت می‌توانید آمار میزان همکاری
  در فروش خود را مشاهده کنید.
  `,
  SETTLEMENT_REQ_BTN: 'درخواست تسویه',
  SUBMIT_INFO_BTN: 'ثبت اطلاعات',
  CURRENCY_SUFFIX: 'تومان',

  ACCOUNT_INFO_NOT_CORRECT_ERROR: 'اطلاعات حساب شما صحیح نمی‌باشد!',
  MIN_SETTLEMENT_AMOUNT_ERROR: 'حداقل مبلغ قابل تسویه 500 هزار تومان می‌باشد!',
  MIN_SHEBA_LENGTH_ERROR: 'شماره شبا باید حداقل ۲۴ رقم باشد!',

  CHART_TOOLTIP_INCOME: 'مبلغ درآمد',
  AFFILIATE_WITH_RAYCHAT: 'سیستم همکاری در فروش رایچت',
  KNOW_MORE: 'بیشتر بدانید',
  STATISTICS_TITLE: 'آمار و ارقام',
  MORE_INFO_BOX_TITLE: 'تعداد کاربران تا به امروز',
};

export default AFFILIATE;
